// import gsap from "gsap";
document.addEventListener("DOMContentLoaded", () => {
  const languages = document.querySelectorAll(".header-language");
  const navMobile = document.querySelector('.nav-mobile');
  languages.forEach((language) => {
    // const languageList = language.querySelector(".header-language__list");
    // const duration = 0.3;
    // let timeline = gsap.timeline();

    language.addEventListener("touchstart", () => {
      setTimeout(() => {
        navMobile.scrollTo(
          {
            top:navMobile.scrollHeight,
            behavior: "smooth"
          }
        )
      },150)

      // timeline.to(language, { backgroundColor: "var(--grey)", duration });
      // if (languageList) timeline.to(languageList, { height: "auto", duration });
    });
    // language.addEventListener("touchend", () => {
    //   // if (languageList) timeline.to(languageList, { height: "0", duration });
    //   // timeline.to(language, { backgroundColor: "transparent", duration });
    // });
  });
});
